import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {PageLoader} from "../../components/Loader";
import _ from "lodash";
import ErrorNotFound from "../ErrorNotFound";
import ContentPage from "./ContentPage";
import {fetchFacetteByAncre,resetFacette} from "../../../creators/facette";
import createLink from "../../../libs/createLink";


class FacettesAncre extends React.Component {
    constructor(props) {
        super(props);

        //this.currentCategorySlug = _.get(this.props,"match.params.categorySlug");
        this.state = {
            lastUpdate : new Date(),
            //currentCategory : ""
        };
        this.facetteAncre = _.get(this.props,"location.hash");
        if(!this.facetteAncre){
            this.props.history.push(createLink("facette",{slug : "video-amateur/"}))
        }

        this.props.resetFacette();
        this.props.fetchFacetteByAncre(encodeURIComponent(this.facetteAncre));

    }

    fetchLastCategory(){
        let categoryId = null;
        let currentCat = this.facetteAncre;
        currentCat = currentCat.split('/').filter(item => item).pop();
        let cat = _.get(this.props.facette, "categoriesValues") || [];
        cat.forEach(item => {
            if(currentCat.includes(item.value.slug)){
                categoryId = item.value._id;
            }
        });
        return categoryId
    }

    fetchCategories(){
        let categories = _.get(this.props.facette, "categoriesValues") || [];
        categories = [...categories];
        let cat = [];
        categories.forEach(item =>{
            //cat.push(item.category._id);
            cat.push(item.value._id);
        });

        return cat.filter(item => item !== "");
    }



    componentDidUpdate(prevProps, prevState, snapshot) {
        if(_.get(prevProps,"location.hash") !== _.get(this.props,"location.hash")){
            this.facetteAncre = _.get(this.props,"location.hash");
            this.props.resetFacette();
            this.props.fetchFacetteByAncre(encodeURIComponent(this.facetteAncre));
            this.setState({lastUpdate : new Date()});
        }
    }


    render() {

        return !this.props.facetteInitialized && this.props.facetteError.statusCode !== 404 ? (
                <div id="facettes">
                    <div className="container">
                        <div className="card big">
                            <PageLoader/>
                        </div>
                    </div>
                </div>
            )
            : this.props.facetteError.statusCode === 404 ? (
                    <ErrorNotFound />
                )
                : (
                    <ContentPage location={this.props.location} match={this.props.match} currentCategory={this.fetchLastCategory()} categories={this.fetchCategories()} facette={this.props.facette} facetteAncre={this.facetteAncre} />
                )
    }
}

const mapStateToProps = (state) => {
    return {
        facette : state.facette.data,
        facetteError : state.facette.error,
        facetteInitialized : state.facette.initialized,
        facetteLoading : state.facette.loading,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchFacetteByAncre,
    resetFacette
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FacettesAncre);
